'use client';

import H3 from '@/components/typography/h3';
import P from '@/components/typography/p';
import { gsap } from 'gsap';
import { useRef } from 'react';

type PrServiceItem = {
    title: string;
    description: string;
};

interface PrServiceCardProps {
    item: PrServiceItem;
}

export default function PrServiceCard({ item }: PrServiceCardProps) {
    const cardRef = useRef<HTMLDivElement>(null);
    const overlayRef = useRef<HTMLDivElement>(null);

    const blue = 'oklch(0.8141 0.0822 302.25)';
    const base = 'oklch(0.9764 0.0132 106.64)';

    const handleMouseEnter = () => {
        if (!cardRef.current || !overlayRef.current) return;

        gsap.to(cardRef.current, {
            y: -10,
            duration: 0.3,
            ease: 'power2.out',
            border: '1px solid transparent',
        });

        gsap.to(overlayRef.current, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out',
        });
    };

    const handleMouseLeave = () => {
        if (!cardRef.current || !overlayRef.current) return;

        gsap.to(cardRef.current, {
            y: 0,
            duration: 0.6,
            border: '1px solid black',
            ease: 'power2.inOut',
        });

        gsap.to(overlayRef.current, {
            opacity: 0,
            duration: 0.6,
            ease: 'power2.inOut',
        });
    };

    return (
        <div
            ref={cardRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="border-primary relative flex flex-col gap-[1.87rem] rounded-lg border px-[1.4rem] pt-[1.25rem] pb-[1.4rem]"
            style={{ backgroundColor: base }}
        >
            <div
                ref={overlayRef}
                style={{ backgroundColor: blue }}
                className="pointer-events-none absolute inset-0 z-0 rounded-lg opacity-0"
            />
            <div className="relative z-10 flex flex-col gap-6">
                <H3>{item.title}</H3>
                <P>{item.description}</P>
            </div>
        </div>
    );
}
